import { AbgSxProps } from '@abg/typings';

export const dialogContainerStyling: AbgSxProps = {
  zIndex: 1400, // Above the header
  '& .MuiDialog-container': {
    alignItems: { xs: 'end', sm: 'center' },
  },
  '& .MuiDialog-paper': {
    width: { xs: '100%', sm: '500px' },
    maxWidth: { sm: '500px' },
    margin: { xs: 0, sm: '32px' },
  },
};

export const dialogHeaderStyling: AbgSxProps = {
  position: 'relative',
  width: '100%',
  padding: 0,
};

export const closeIconStyling: AbgSxProps = {
  position: 'absolute',
  zIndex: 1,
  top: '16px',
  right: '16px',
  width: '16px',
  height: '16px',
  cursor: 'pointer',
};

export const imageContainerStyling: AbgSxProps = {
  position: 'relative',
  width: '100%',
  height: '250px',
};

export const dialogContentStyling: AbgSxProps = {
  width: '100%',
  padding: '24px 32px 0 !important', // to override default dialog padding
  scrollbarWidth: 'thin',
};

export const dialogTitleStyling: AbgSxProps = {
  paddingBottom: '4px',
  textAlign: 'center',
};

export const dialogSubtitleStyling: AbgSxProps = {
  marginBottom: '24px',
  textAlign: 'center',
  '& p': { margin: 0 },
};

export const itemContainerStyling: AbgSxProps = {
  width: '100%',
  padding: '16px',
  '&:not(:last-child)': {
    marginBottom: '10px',
  },
};

export const itemHeaderStyling: AbgSxProps = {
  display: 'flex',
  marginBottom: '8px',
  alignItems: 'center',
};

export const itemIconContainerStyling: AbgSxProps = {
  width: '24px',
  height: '24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const itemIconStyling: AbgSxProps = {
  position: 'relative',
  width: '16px',
  height: '16px',
};

export const itemTitleStyling: AbgSxProps = {
  flex: 1,
  marginLeft: '4px',
};

export const itemLabelStyling: AbgSxProps = {
  marginLeft: '50px',
};

export const itemSubtitleStyling: AbgSxProps = {
  '& p': { margin: 0 },
};

export const dialogActionsStyling: AbgSxProps = {
  width: '100%',
  padding: { xs: '20px 32px', sm: '24px 32px' },
  justifyContent: 'center',
};

export const dialogButtonStyling: AbgSxProps = {
  height: { xs: '48px', sm: '40px' },
  padding: '0 16px',
  maxWidth: '300px',
};
